module.exports = __webpack_public_path__ + "static/media/laptops-right.d77ff7bc.jpg";